import {AxiosProcessor} from "../../shared/axios/AxiosProcessor";
const urlGroupType = '/groupType';

const state = {
    groupType: {},
    groupTypes:[]
};

const getters = {
    getGroupType: state => {
        return state.groupType;
    },
    getGroupTypes: state => {
        return state.groupTypes;
    }
};

const mutations = {
    setGroupType: (state, data) => {
        state.groupType = data;
    },
    setGroupTypes: (state, data) => {
        state.groupTypes = data;
    }
};

const actions = {
    async setGroupType ({commit}, data) {
        //going backend
        let value = {};

        try
        {
            if(data.id) {
                value = await AxiosProcessor.put(urlGroupType+'/' + data.id, data);
            }
            else {
                value  = await AxiosProcessor.post(urlGroupType, data);
            }
        }
        catch (e) {
            throw e;
        }

        commit('setGroupType', value);
    },
    async getGroupType ({commit}, data) {
        let id = data.id;

        if (!id)
            throw {message: 'empty id. Please provide a valid id value'};

        /**
         * First we check the state
         * then we check the list
         * then we go to backend
         */
        if(state.groupType.id && state.groupType.id === id)
            return;

        let groupType;
        let value = {};

        if (state.groupTypes.length > 0)
            groupType  = state.groupTypes.find(doc => doc.id === id);

        if(groupType)
        {
            value = groupType;
        }
        else
        {
            let response = await AxiosProcessor.get(urlGroupType+'/'+id);

            if(response.Item)
                value = response.Item;
        }

        commit('setGroupType', value);
    },
    async deleteGroupType ({commit}, data){
        //going backend,
        let value = {};
        value = await AxiosProcessor.delete(urlGroupType+'/'+data.id);

        commit('setGroupType', value);
    }
};

export default {
    state,
    getters,
    mutations,
    actions
}